import React, { useEffect } from "react";
import PropTypes from "prop-types";

const HubspotBanner = (props) => {
  const { bannerId, altText, altUrl, throttling } = props;
  useEffect(() => {
    if (window.hbspt) {
      window.hbspt.cta.load(4384097, bannerId, {});
    }
  }, []);
  if (window.hbspt) {
    return (
      <div className="hs-cta-wrapper" id={`hs-cta-wrapper-${bannerId}`}>
        <span
          className={`hs-cta-node hs-cta-${bannerId}`}
          id={`hs-cta-${bannerId}`}
        >
          <a
            href={`https://cta-redirect.hubspot.com/cta/redirect/4384097/${bannerId}`}
            target="_blank"
          >
            <img
              className="hs-cta-img"
              id={`hs-cta-img-${bannerId}`}
              style={{ borderWidth: "0px" }}
              src={`https://no-cache.hubspot.com/cta/default/4384097/${bannerId}.png`}
            />
          </a>
        </span>
      </div>
    );
  }
  if (throttling) {
    return (
      <div className="hs-cta-wrapper" id={`hs-cta-wrapper-${bannerId}`}>
        <span
          className={`hs-cta-node hs-cta-${bannerId}`}
          id={`hs-cta-${bannerId}`}
        >
          <a href="https://landing.varsome.com/contact" target="_blank">
            <img
              className="hs-cta-img"
              id={`hs-cta-img-${bannerId}`}
              style={{ borderWidth: "0px" }}
              alt={altText}
              src={`https://no-cache.hubspot.com/cta/default/4384097/${bannerId}.png`}
            />
          </a>
        </span>
      </div>
    );
  }
  const textVersion = `<div class="tw-p-12 tw-bg-white">${altText}.<br/><br/>Learn more <a href=${altUrl} target="_blank" >here</a></div>`;
  // eslint-disable-next-line react/no-danger
  return <div dangerouslySetInnerHTML={{ __html: textVersion }} />;
};

HubspotBanner.propTypes = {
  bannerId: PropTypes.string.isRequired,
  altText: PropTypes.string.isRequired,
  altUrl: PropTypes.string.isRequired,
  throttling: PropTypes.bool,
};

HubspotBanner.defaultProps = {
  throttling: false,
};

export default HubspotBanner;
